import { render } from "./FlyBasket.vue?vue&type=template&id=46a2c069&scoped=true"
import script from "./FlyBasket.vue?vue&type=script&lang=js"
export * from "./FlyBasket.vue?vue&type=script&lang=js"

import "./FlyBasket.vue?vue&type=style&index=0&id=46a2c069&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a2c069"]])

export default __exports__